import RepaymentDetail from './RepaymentDetail'

export default RepaymentDetail
